export default "__VITE_ASSET__DZDsLS$h__";